import { Button, Spinner, Tooltip } from "@fluentui/react-components";
import { ArrowClockwise20Regular } from "@fluentui/react-icons";

import { useListAutoRefresh } from "@/features/documents/useListAutoRefresh";

/**
 * Top-right refresh button for the list views. Renders a single
 * subtle Refresh button. Auto-refresh continues to run on a 30s
 * timer and pauses while a detail panel is open or the tab is
 * hidden — the manual button always works.
 */
export function RefreshControl() {
  const { refresh, isRefreshing, isAutoRefreshActive } = useListAutoRefresh();

  const tooltip = isAutoRefreshActive
    ? "Refreshes automatically every 30 seconds"
    : "Auto-refresh paused while a detail panel is open or the tab is in the background";

  return (
    <Tooltip content={tooltip} relationship="label">
      <Button
        appearance="subtle"
        size="small"
        icon={
          isRefreshing ? (
            <Spinner size="tiny" />
          ) : (
            <ArrowClockwise20Regular aria-hidden="true" />
          )
        }
        onClick={() => {
          void refresh();
        }}
        disabled={isRefreshing}
        aria-label="Refresh list"
        data-testid="refresh-button"
      >
        Refresh
      </Button>
    </Tooltip>
  );
}
